<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">信用证还款</a>
        </span>
        <span v-else>信用证还款</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <div style="padding-left: 16px;">
            <span class="desc" v-if="item.number">还证编号：{{ item.number }}</span>
            <span class="desc" v-if="item.credit_letter">信用证编号：{{ item.credit_letter }}</span>
            <span class="desc" v-if="item.bank">银行：{{ item.bank }}</span>
            <span class="desc" v-if="item.bank_credit_letter_number">银行信用证编号：{{ item.bank_credit_letter_number }}</span>
            <span class="desc" v-if="item.amount">金额：{{ (item.amount).toFixed(2) | numberFormat }}</span>
            <span class="desc" v-if="item.to_cny_rate">信用证货币到人民币的汇率：{{ item.to_cny_rate }}%</span>
            <span class="desc" v-if="item.amount_cny">预估人民币金额：{{ (item.amount_cny).toFixed(2) | numberFormat }}</span>
            <span class="desc" v-if="item.financing_rate && false">融资利率：{{ item.financing_rate }}%</span>
            <span class="desc" v-if="item.total_amount">总金额：{{ (item.total_amount).toFixed(2) | numberFormat }}</span>
            <span class="desc" v-if="item.repayment_date">还款日期：{{ item.repayment_date }}</span>
            <span class="desc">是否押汇：{{ item.is_bill_negotiation ? '是' : '否' }}</span>
            <span class="desc" v-if="item.is_bill_negotiation && item.bill_negotiation_limit !== undefined">押汇额度占用：{{ (item.bill_negotiation_limit).toFixed(2) | numberFormat }}</span>
            <span class="desc" v-if="item.is_bill_negotiation && item.repayment_bill_negotiation_limit !== undefined && item.repayment_bill_negotiation_limit > 0" @click="showBillNegotiation(item)"><a>已还押汇额度占用：{{ (item.repayment_bill_negotiation_limit).toFixed(2) | numberFormat }}</a></span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_credit_letter_repayment', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'credit_letter_repayment')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
          </div>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="!item.is_archived && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'credit_letter_repayment')" v-if="!item.is_approval_needed">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'credit_letter_repayment')">
                <span v-if="(item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_credit_letter_repayment', true)">
                <span>重启审批</span>
              </a-popconfirm>
              <span v-if="item.is_bill_negotiation && item.bill_negotiation_limit !== undefined" @click="handleAddBillNegotiation(item, 'CreateBillNegotiationForm')">押汇额度占用还款</span>
            </span>
          </div>
          <div>
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle" v-if="item.attachment.length > 0">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
              <a-collapse-panel key="3" header="详情" :style="customStyle" v-if="false">
                <div v-for="(d) in item.detail" :key="d.id">
                  <span class="desc">银行：{{ d.bank }}</span>
                  <span class="desc">金额：{{ (d.amount).toFixed(2) | numberFormat }}</span>
                  <span class="desc">信用证货币到人民币的汇率：{{ d.to_cny_rate }}%</span>
                  <span class="desc">预估人民币金额：{{ (d.amount_cny).toFixed(2) | numberFormat }}</span>
                  <span class="desc" v-if="false">融资利率：{{ d.financing_rate }}%</span>
                  <span class="desc">总金额：{{ (d.total_amount).toFixed(2) | numberFormat }}</span>
                  <span class="desc">还款日期：{{ d.repayment_date }}</span><br>
                  <span class="desc" v-if="d.remark">备注：{{ d.remark }}</span>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'CreditLetterRepaymentInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      const path = '/trade/credit_letter_repayment'
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    handleAddBillNegotiation (item, type) {
      this.$emit('handleAddBillNegotiation', item, type)
    },
    showBillNegotiation (item) {
      this.$emit('showBillNegotiation', item)
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
